import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export default (function (object, organisationKey, serialNumber, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.DEVICE_UPDATE_NAME, { organisationId: organisationKey, device: serialNumber });
    var request = new Request({
        method: Methods.POST,
        url: url,
        data: object,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
